"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var live_poll_1 = require("../../../common/utils/live-poll");
var live_1 = require("../../../common/ui-selectors/video/live");
var LivePolling = /** @class */ (function (_super) {
    tslib_1.__extends(LivePolling, _super);
    function LivePolling() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeouts = [];
        _this.pollVideo = function (videoItem) {
            var getVideoData = _this.props.getVideoData;
            var id = videoItem.id;
            var step = live_poll_1.getPollStep(videoItem);
            if (!step) {
                return;
            }
            getVideoData(id)
                .then(_this.onPollResponse)
                .then(function (changedVideoItem) {
                return _this.checkStatusChange(videoItem, changedVideoItem);
            })
                .then(_this.handleStatusChange)
                .then(function (changedVideoItem) {
                if (changedVideoItem) {
                    _this.timeouts[id] = setTimeout(function () { return _this.pollVideo(changedVideoItem); }, step);
                }
            })
                .catch(function (e) { return _this.onPollResponse({ data: videoItem }, e); });
        };
        _this.onPollResponse = function (response, error) {
            var data = response.data;
            _this.props.onPoll(data, error);
            return data;
        };
        _this.checkStatusChange = function (videoItem, changedVideoItem) {
            var _a = _this.props, onStreamChangePending = _a.onStreamChangePending, onStreamChangeReady = _a.onStreamChangeReady;
            var changedVideoItemWithPaymentInfo = videoItem;
            if (!changedVideoItem) {
                return {
                    ready: false,
                    changedVideoItem: changedVideoItemWithPaymentInfo,
                };
            }
            if (!live_1.isPendingLiveStream(videoItem) &&
                live_1.isPendingLiveStream(changedVideoItem)) {
                changedVideoItemWithPaymentInfo = tslib_1.__assign(tslib_1.__assign({}, changedVideoItem), { dgsInfo: videoItem.dgsInfo });
                onStreamChangePending(changedVideoItemWithPaymentInfo);
                return {
                    ready: false,
                    changedVideoItem: changedVideoItemWithPaymentInfo,
                };
            }
            if (!live_1.isReadyLiveStream(videoItem) && live_1.isReadyLiveStream(changedVideoItem)) {
                changedVideoItemWithPaymentInfo = tslib_1.__assign(tslib_1.__assign({}, changedVideoItem), { dgsInfo: videoItem.dgsInfo });
                onStreamChangeReady(changedVideoItemWithPaymentInfo);
                return { ready: true, changedVideoItem: changedVideoItemWithPaymentInfo };
            }
            return { ready: false, changedVideoItem: changedVideoItemWithPaymentInfo };
        };
        _this.handleStatusChange = function (status) {
            var autoplayVideo = _this.props.autoplayVideo;
            var ready = status.ready, changedVideoItem = status.changedVideoItem;
            if (ready && changedVideoItem) {
                autoplayVideo(changedVideoItem);
                return null;
            }
            return status.changedVideoItem;
        };
        return _this;
    }
    LivePolling.prototype.componentDidMount = function () {
        var _a = this.props, scheduledVideos = _a.scheduledVideos, pendingVideos = _a.pendingVideos;
        lodash_1.forEach(scheduledVideos, this.pollVideo);
        lodash_1.forEach(pendingVideos, this.pollVideo);
        this.handleInitialStreaming();
    };
    LivePolling.prototype.componentWillUnmount = function () {
        lodash_1.forEach(this.timeouts, function (timeoutId) { return clearTimeout(timeoutId); });
    };
    LivePolling.prototype.handleInitialStreaming = function () {
        var _a = this.props, streamingVideos = _a.streamingVideos, canInitiallyAutoplay = _a.canInitiallyAutoplay;
        var firstStreaming = streamingVideos && streamingVideos[0];
        if (firstStreaming && canInitiallyAutoplay(firstStreaming.id)) {
            this.props.autoplayVideo(firstStreaming);
        }
    };
    LivePolling.prototype.render = function () {
        return null;
    };
    LivePolling.propTypes = {
        scheduledVideos: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            id: prop_types_1.default.string,
            dateStartLive: prop_types_1.default.number,
        })),
        pendingVideos: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            id: prop_types_1.default.string,
        })),
        streamingVideos: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            id: prop_types_1.default.string,
        })),
        autoplayVideo: prop_types_1.default.func,
        canInitiallyAutoplay: prop_types_1.default.func,
        onStreamChangePending: prop_types_1.default.func,
        onStreamChangeReady: prop_types_1.default.func,
        onPoll: prop_types_1.default.func,
        getVideoData: prop_types_1.default.func,
    };
    return LivePolling;
}(react_1.default.Component));
exports.default = LivePolling;
//# sourceMappingURL=live-polling.js.map